/**
 * @generated SignedSource<<68f2d997a99b4eedaa8f6c161a8f1bf6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerApplicationForm_viewer$data = {
  readonly readFromSF: boolean | null;
  readonly salesforceSellerLead: {
    readonly averageItemPrice: string | null;
    readonly businessType: string | null;
    readonly city: string | null;
    readonly company: string | null;
    readonly country: string | null;
    readonly currencyISOCode: string | null;
    readonly email: string | null;
    readonly eori: string | null;
    readonly estimatedInventorySize: string | null;
    readonly estimatedMonthlyUploads: string | null;
    readonly facebook: string | null;
    readonly firstName: string | null;
    readonly galleryRepresentation: boolean | null;
    readonly hasExperienceSellingOnline: boolean | null;
    readonly hoursManagePerWeek: string | null;
    readonly instagram: string | null;
    readonly isSellerOnOtherMarketPlace: boolean | null;
    readonly lastName: string | null;
    readonly nmiReason: string | null;
    readonly numSoldLastYear: string | null;
    readonly otherMarketPlaceDetails: string | null;
    readonly phone: string | null;
    readonly postalCode: string | null;
    readonly primaryBusinessFocus: string | null;
    readonly recordId: string | null;
    readonly specialty: string | null;
    readonly state: string | null;
    readonly status: string | null;
    readonly street: string | null;
    readonly website: string | null;
    readonly whereRepresented: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationFormSelector_viewer">;
  readonly " $fragmentType": "SellerApplicationForm_viewer";
};
export type SellerApplicationForm_viewer$key = {
  readonly " $data"?: SellerApplicationForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationForm_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "leadId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerApplicationForm_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellerApplicationFormSelector_viewer"
    },
    {
      "alias": "readFromSF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "sellerLeadReadFromSF"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"sellerLeadReadFromSF\")"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "leadId",
          "variableName": "leadId"
        }
      ],
      "concreteType": "SellerLeadSalesforceType",
      "kind": "LinkedField",
      "name": "salesforceSellerLead",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recordId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "company",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "street",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postalCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryBusinessFocus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eori",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasExperienceSellingOnline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "businessType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "galleryRepresentation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "whereRepresented",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "specialty",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimatedInventorySize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencyISOCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "averageItemPrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numSoldLastYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimatedMonthlyUploads",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSellerOnOtherMarketPlace",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "otherMarketPlaceDetails",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hoursManagePerWeek",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "instagram",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "facebook",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "website",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nmiReason",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9b64bb11e5501f9f6200633abb704251";

export default node;
